import React, { useState, useEffect } from 'react';
import { text } from '../data';
import { TabData } from '../types/types';
import Tabs from '../components/Tabs';
import NumberInput from '../../components/bearing-search/components/forms/NumberInput';
import { getTooltip } from '../utils/engineering-tools';
import { ConversionToolTabs } from './types';
import { useConversion } from './ConversionContext';
import TabGeneral from './Tabs/General/TabGeneral';
import TabTemperature from './Tabs/Temperature/TabTemperature';
import TabStiffness from './Tabs/Stiffness/TabStiffness';
import TabAngle from './Tabs/Angle/TabAngle';
import TabSpeed from './Tabs/Speed/TabSpeed';
import Tooltip from './Utils/Tooltip';
import { trackStart } from '../utils/analytics';

const ConversionTool: React.FC = () => {
	// get conversion tool tabs
	const conversionToolTabs = window?._timken?.conversion_tool_tabs as ConversionToolTabs || {};

	const { precision, setPrecision, exponent, setExponent } = useConversion();

	useEffect(() => {
		trackStart( 'conversionTool' );
	}, []);

	// create tabs component data
	const tabs: TabData[] = [
		{
			id: 'conversion_general',
			title: conversionToolTabs.general.title,
			content: <TabGeneral description={conversionToolTabs.general.description} />,
		},
		{
			id: 'conversion_temperature',
			title: conversionToolTabs.temperature.title,
			content: <TabTemperature description={conversionToolTabs.temperature.description} />,
		},
		{
			id: 'conversion_stifness',
			title: conversionToolTabs.stiffness.title,
			content: <TabStiffness description={conversionToolTabs.stiffness.description} />,
		},
		{
			id: 'conversion_angle',
			title: conversionToolTabs.angle.title,
			content: <TabAngle description={conversionToolTabs.angle.description} />,
		},
		{
			id: 'conversion_speed',
			title: conversionToolTabs.speed.title,
			content: <TabSpeed description={conversionToolTabs.speed.description} />,
		},
	];

	const [ activeSearchTab, setActiveSearchTab ] = useState(tabs[ 0 ].id); // select first by default

	/**
	 * Handle tab change
	 *
	 * @param {string} id
	 */
	const handleTabChange = (id: string) => {
		setActiveSearchTab(id);
	};

	/**
	 * @param {number} value
	 */
	const handlePrecisionChange = (value: number) => {
		const validPrecision = Math.min(value, 6);
		setPrecision(validPrecision);
	};

	/***/
	const handleExponentChange = () => {
		setExponent(! exponent);
	};

	return (
		<>
			<div className='mb-4' dangerouslySetInnerHTML={{__html: conversionToolTabs.general.description}}/>
			<div className='row align-items-center g-0 mb-5'>
				<div className="col col-md-4 col-conversion-category-label">
					<span>{text.precision}</span>
					<Tooltip content={getTooltip(text.precision)} className={"a-tooltip__text a-tooltip__text--right a-tooltip__text--mobile"} />
				</div>

				<div className="col col-md-8">
					<div className="row align-items-center mx-0">
						<div className="col-2 col-md-1 px-0">
							<NumberInput
								id="conversion_precision"
								label={''}
								value={precision}
								min={0}
								max={6}
								onChange={(e) => {
									handlePrecisionChange(Number(e.target.value));
								}}
								onFocus={(e) => e.target.select()}
							/>
						</div>

						<div className="col-10 col-md-4 pe-0">
							<div className="m-checkbox">
								<input
									id="conversion_exponent"
									className="m-checkbox__input"
									type="checkbox"
									name="conversion_exponent"
									onChange={handleExponentChange}
								/>
								<label className="m-checkbox__label" htmlFor="conversion_exponent">
									{text.scientificNotation}<Tooltip content={getTooltip(text.scientificNotation) } className={"a-tooltip__text a-tooltip__text--right"} />
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Tabs
				title={text.searchOptions}
				tabs={tabs}
				defaultTab={activeSearchTab}
				onChange={handleTabChange}
			/>
		</>
	);
};

export default ConversionTool;
